<!-- eslint-disable max-len -->
<template>
  <div
    :id='id' class='c-modal modal' tabindex='0'
    style=' z-index: 1003; display: none; opacity: 0; top: 4%; transform: scaleX(0.8) scaleY(0.8)'
  >
    <div v-if='!addCard && !addYapeInfo' class='type-card-container'>
      <div class='text-2xl-bold'>Método de pago</div>
      <div style='display: flex; flex-direction: column; gap: 16px;'>
        <ButtonDefinitive
          variant='ghost'
          label='Agregar tarjeta'
          @click='addCard = true'
        >
          <template v-slot:icon>
            <Icon name='Plus4' />
          </template>
        </ButtonDefinitive>

        <div v-for='card in cards' :key='card.cardId' class='card_info-button' @click="selectCard(card)">
          <Icon name='BankCardDouble' :size='26' strokeColor='#FF6568' />
          <div style=''>
            <div class='text-m-bold'>{{ card.name }}</div>
            <div class='text-xs-light' style='flex-grow: 1;'>
              {{ cardsBrand[card.cardBrand] }}  ·  terminada en {{ card.cardNumber.slice(-4) }}
            </div>
          </div>
        </div>

        <!-- Pago efectivo -->
        <!-- <div class='card_info-button' @click="sendPagoEfectivo">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.359 3.951C9.777 1.973 6.596.851 4.752.851c-.508 0-.91.08-1.203.267-1.577.989-2.54 7.084-2.166 13.58.294 5.159 1.31 7.912 2.192 8.313 1.55.748 7.057-1.337 12.484-4.785 4.598-2.887 6.63-5.132 6.63-6.095.026-1.684-4.09-5.293-9.33-8.18" fill="#FC0"/>
            <path d="M13.759 3.203C11.86 2.161 5.499-1.127 3.093.396S.26 9.806.527 14.751c.133 2.406.695 8.1 2.673 9.035.32.16.722.214 1.203.214 2.78 0 7.939-2.433 12.11-5.052 2.11-1.337 7.03-4.651 7.03-6.817.026-2.432-5.053-6.335-9.784-8.928m2.299 15.05c-5.453 3.421-10.933 5.533-12.484 4.785-.882-.428-1.871-3.155-2.192-8.314-.374-6.495.588-12.59 2.165-13.58.294-.186.695-.266 1.203-.266 1.845 0 5.026 1.122 8.608 3.1 5.24 2.887 9.356 6.496 9.356 8.207 0 .935-2.059 3.18-6.656 6.068" fill="#fff"/>
            <path d="M14.854 7.667c-.855-.534-2.085-.802-3.636-.802-1.497 0-2.78.08-3.902.214q-.322.04-.481.16a.68.68 0 0 0-.241.348L6.3 9.111h4.277l.214-1.39 2.78 3.395-3.85 3.314.241-1.55H5.525l-1.31 6.442v.08c0 .08.027.16.08.187a.3.3 0 0 0 .214.08h1.978a.45.45 0 0 0 .294-.106.4.4 0 0 0 .16-.241l.91-3.85h.32c.134 0 .294.027.454.027s.321 0 .508.027h.455c1.096 0 2.058-.16 2.914-.347 2.646-.535 3.635-3.208 3.635-5.266q.04-1.444-1.283-2.246" fill="#000"/>
          </svg>
          <div class='text-m-regular'>PagoEfectivo</div>
        </div> -->

        <!-- Pago por yape -->
        <!-- <div class='card_info-button' @click="sendYape">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.842 10.101c-.064-.465-.258-.856-.625-1.148-.61-.316-1.189 0-1.61.443l-.097.105c-.035-.179-.053-.24-.187-.374l-.033-.002c-.161-.01-.305-.02-.466.002-.322.215-.515.403-.622.784l-.033.132-.079.288-.114.427q-.168.592-.328 1.187l-.055.21-.115.431q-.126.494-.275.981l-.063.187c-.027.087-.04.128-.056.167-.015.036-.034.07-.07.136-.148.111-.254.141-.437.187-.02-.417.02-.8.105-1.208l.047-.216c.142-.657.32-1.295.527-1.934l.067-.196c.102-.289.205-.582.216-.888a.6.6 0 0 0-.036-.161c-.022-.046-.062-.084-.15-.167-.239-.109-.392-.123-.651-.098a.6.6 0 0 0-.103.059c-.041.032-.072.077-.154.195l-.117.183-.042-.04a2 2 0 0 0-.231-.15c-.378-.187-.773-.187-1.17-.06-.925.643-1.479 1.547-1.857 2.596l-.07.213c-.247.741-.3 1.445-.264 2.224.04.431.19.733.513 1.021.347.207.667.224 1.061.188.378-.088.69-.394.901-.71l.098-.164c.079.238.164.42.374.561.339.056.653.026.983-.062l.14-.062c-.098.301-.191.596-.23.912l-.02.211c-.228.007-.382.012-.535.024-.314.023-.627.075-1.58.231l-.687.114c-.82.133-1.634.271-2.442.46l-.185.045a2 2 0 0 0 .061-.129c.012-.03.022-.06.04-.119q.096-.338.206-.672.196-.572.357-1.154l.272-.984c.113-.41.23-.815.36-1.219.2-.618.4-1.236.58-1.86l.059-.206.03-.102c.084-.283.167-.565.177-.863-.02-.181-.02-.181-.145-.306-.3-.023-.536.002-.811.125a2 2 0 0 0-.35.25c-.199.195-.3.49-.632 1.45-.212.627-.427 1.247-.721 1.84l-.107.204-.024.048c-.173.335-.345.67-.589.961-.239.225-.434.289-.76.302l-.008-.246c.03-.344.046-.516.082-.684.035-.17.092-.334.205-.665q.062-.18.13-.362c.225-.619.458-1.258.402-1.913a1.5 1.5 0 0 0-.499-.312c-.257-.04-.47-.048-.702.074a.5.5 0 0 0-.098.118.5.5 0 0 0-.033.155c.02.351.02.611-.101.943l-.11.28c-.349.892-.697 1.781-.732 2.751l-.003.15c-.004.178-.002.346.032.522.135.322.302.54.624.687a1.9 1.9 0 0 0 1.463-.36l.147-.118.15-.119.112-.09-.15.46-.06.191a11 11 0 0 0-.303 1.048l-.049.236c-.224 0-.36.03-.566.11l-.12.05c-1.415.576-2.767 1.58-3.471 2.963l-.087.184c-.218.458-.329.858-.342 1.362v.168c-.003.37.013.645.218.967.378.378.746.507 1.272.518h.417c.578-.044 1.12-.41 1.508-.83l.11-.125c.833-.905 1.355-2.063 1.806-3.196l.059-.15a5 5 0 0 0 .238-.712l.02-.123c.167 0 .222 0 .276-.007.027-.003.053-.008.093-.015l.128-.031.15-.036a50 50 0 0 1 4.782-.91 3 3 0 0 0-.062.811c.036.065.053.096.078.12.023.022.052.037.109.067.216.03.362.005.57-.062.366-.255.452-.66.535-1.08l.018-.106q.284.006.567-.015l.205-.021.228-.024.364-.038.074-.008c.343-.036.686-.072 1.028-.117.432-.058.86-.101 1.294-.132a73 73 0 0 0 1.863-.15l.244-.025.236-.023.22-.022c.24-.024.338-.037.542-.174a.95.95 0 0 0 .148-.39l.004-.144c.004-.074.006-.11.002-.146-.003-.033-.012-.066-.029-.13a1 1 0 0 0-.182-.153c-.108-.057-.247-.056-.642-.055l-.202.004-.642.01-.204.006a38 38 0 0 0-4.513.402l-.23.035a7 7 0 0 0 .355-1.36l.019-.138h.125v.125c.13.117.216.184.374.25.345.04.675.021.997-.115l.123-.061c.213-.104.385-.232.565-.386 1.07-1.034 1.548-2.361 1.585-3.837l.003-.18a7 7 0 0 0-.005-.5M11.87 11.89c.123-.375.272-.827.084-1.202-.215-.06-.347-.095-.468-.072-.19.037-.35.222-.765.699-.555.732-.933 1.754-.826 2.68.084.169.161.26.312.375.099.006.151.008.203.002a1.3 1.3 0 0 0 .233-.064 3.3 3.3 0 0 0 .392-.376c.21-.257.327-.59.695-1.637l.068-.199.066-.19zm4.515-1.514a.62.62 0 0 1 .214.42c.001.541-.1 1.004-.276 1.515l-.057.17c-.218.596-.525 1.112-1.059 1.468-.195.069-.364.061-.57.047l-.186-.125c.034-.508.168-.967.32-1.451l.069-.234c.38-1.23.52-1.683.809-1.816.168-.078.388-.046.736.006M4.644 20.442c.187-.393.329-.785.444-1.205-.09 0-.151 0-.21.01-.13.024-.249.099-.628.334-.863.578-1.667 1.412-1.883 2.457l-.005.04c-.032.249-.047.364.105.591.217.03.34.018.536-.082l.154-.113c.633-.45 1.076-1.188 1.413-1.877z" fill="#752585"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.512.701c.74.55 1.366 1.399 1.534 2.322.03.275.038.545.038.822l.002.151c.003 1.01-.427 1.913-1.11 2.646-.59.566-1.448 1.055-2.283 1.047l-.208-.011c-1.013-.087-1.013-.087-1.909.298l-.17.16-.138.117a2 2 0 0 1-.136-.027l-.114-.035-.002-.235-.01-.308v-.154c-.01-.266-.02-.39-.192-.602l-.17-.137c-.761-.739-1.234-1.696-1.27-2.763-.013-1.058.328-2.012 1.062-2.783 1.41-1.41 3.412-1.597 5.076-.508M12.12 2.43c.196.12.309.239.394.457.01.09.015.131.014.173 0 .036-.005.072-.014.139-.068.067-.099.098-.136.118a.6.6 0 0 1-.133.042c-.191-.04-.22-.08-.318-.224l-.018-.026-.075-.12a.4.4 0 0 0-.07-.102.4.4 0 0 0-.124-.063l-.128-.012c-.037-.003-.073-.003-.149-.003l-.148-.005c-.17.025-.223.071-.324.208-.008.086-.012.126-.012.167 0 .037.005.074.012.145.305.106.608.2.92.28.312.085.54.163.754.414.133.323.115.62.003.948-.177.254-.387.382-.678.48-.68.045-.874.058-1.044.002a1.5 1.5 0 0 1-.22-.1c-.248-.22-.4-.426-.445-.765a.5.5 0 0 1 .03-.124.6.6 0 0 1 .119-.137 1 1 0 0 1 .15-.02c.04 0 .08.006.162.02.042.062.065.096.087.131.025.042.049.085.1.181.133.177.225.296.448.338.22.008.383-.007.585-.096a.5.5 0 0 0 .09-.118.6.6 0 0 0 .031-.186c-.007-.103-.01-.15-.03-.186-.017-.031-.046-.055-.1-.1-.186-.11-.365-.149-.573-.194l-.034-.008c-.394-.094-.641-.21-.916-.51-.101-.202-.091-.407-.063-.625.125-.26.281-.447.542-.58.415-.125.914-.119 1.31.061m2.058-.204a3 3 0 0 0-.166-.026c-.073.073-.103.103-.127.138a1 1 0 0 0-.053.1l-.056.14-.063.158-.068.17-.143.36a104 104 0 0 1-.372.934l-.07.177c-.153.38-.272.72-.297 1.13l.063.063c.078.004.117.006.156.006s.078-.002.156-.006c.025-.025.04-.04.053-.057a.7.7 0 0 0 .062-.125l.064-.158.073-.18.078-.195.162-.405.171-.428.005-.013.25-.62.079-.2.079-.193.071-.181c.086-.214.117-.332.039-.552a2 2 0 0 0-.146-.037" fill="#11CBB4"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M22.001 9.314a1.8 1.8 0 0 0-.615-.699 1.83 1.83 0 0 0-1.257-.05c-.81.382-1.343 1.05-1.703 1.85-.428 1.034-.848 2.584-.413 3.655.176.349.439.599.805.736.417.052.86.06 1.249-.119l.124-.068c.546-.294.947-.622 1.213-1.19.061-.319.098-.59-.09-.87-.216.019-.342.035-.51.178-.317.368-.652.65-1.112.82l-.019.002c-.184.012-.311.021-.48-.064-.142-.183-.187-.286-.192-.52l.024-.217q.02-.193.043-.386l.161.006c.868-.024 1.652-.478 2.245-1.087.511-.605.587-1.206.527-1.977m-1.139.315a.6.6 0 0 0-.11-.128c-.527-.172-.801.327-1.02.741l-.067.133a2.45 2.45 0 0 0-.285.936c.338 0 .625-.152.888-.36.346-.33.586-.647.633-1.13a.6.6 0 0 0-.039-.192" fill="#752585"/>
          </svg>
          <div class='text-m-regular'>Yape</div>
        </div> -->

      </div>
    </div>
    <div v-if='addCard' class='type-card-container'>
      <div class='text-2xl-bold'>Agregar tarjeta</div>
      <InputText
        placeholder='Alias de la tarjeta'
        v-model='alias'
        missingErrorMessage='Ingresa un alias para la tarjeta.'
        :showEmptyInputError='tryToSubmit && !alias'
        :showExtraMessage="true"
        extraMessage='Los datos de tu tarjeta serán solicitados de forma segura por Izipay.'
      />
      <div :id="`izipay-form-container-${id}`"></div>
      <div>
        <ButtonDefinitive
          label="Continuar con Izipay"
          @click="registerCardWithIzipay()"
        />
        <ButtonDefinitive
          variant='tertiary'
          label="Cancelar"
          @click="handleCloseModal"
        />
      </div>
    </div>
    <div v-if='addYapeInfo' class='type-card-container'>
      <div class='text-2xl-bold'>Añadir datos de yape</div>
      <InputText
        label='Ingresa tu celular Yape'
        placeholder='987 654 321'
        :maxLength=9
        v-model='yapeInfo.number'
        missingErrorMessage='Ingresa tu número de celular yape.'
        :showEmptyInputError='tryToSubmit && !yapeInfo.number'
      />
      <InputText
        label='Código de aprobación'
        :maxLength=6
        v-model='yapeInfo.approbationCode'
        missingErrorMessage='Ingrese código de aprobación.'
        :showEmptyInputError='tryToSubmit && !yapeInfo.approbationCode'
      />
      <div>
        <ButtonDefinitive
          label="Aceptar"
          @click="validateYapeInfo"
        />
        <ButtonDefinitive
          variant='tertiary'
          label="Cancelar"
          @click="handleCloseModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonDefinitive from '@/components/Button/ButtonDefinitive.vue'
import Icon from '@/components/Icon.vue'
import InputText from '@/components/Form/InputText.vue'
import { loadIzipaySdk, getIzipaySession, confirmIzipayCard } from '../../services/izipay'

/* eslint-disable no-undef */
export default {
  name: "ModelTypeCard",
  components: { ButtonDefinitive, Icon, InputText },
  data() {
    return {
      selectedCardId: 0,
      selectedCard: null,
      addCard: false,
      alias: '',
      addYapeInfo: false,
      yapeInfo: {
        number: '',
        approbationCode: ''
      },
      cardsBrand: {
        VS: 'Visa',
        MC: 'MasterCard',
        AE: 'Amex',
        DN: 'Diners'
      },

      tryToSubmit: false
    };
  },
  props: {
    id: String,
  },
  methods: {
    async fetchCards() {
      this.showLoading();
      await this.$store
        .dispatch("GET_CARDS")
        .then((success) => {
          this.$swal.close();
          if (success.status === 200) {
            const cards = success.data.result;
            this.$store.dispatch("GENERAL_SET_CARDS", cards);
          } else {
            this.showError(success.data.message);
          }
        })
        .catch((error) => {
          const msg = error?.data?.message || "Ocurrio un error.";
          this.showError(msg);
        });
    },
    selectCard(card) {
      this.selectedCardId = card.cardId;
      this.selectedCard = card;
      this.sendCard()
    },
    sendCard() {
      this.$emit("getCardData", this.selectedCard);
      this.closeModal(this.id);
    },
    sendPagoEfectivo() {
      this.$emit("getCardData", {cardId: -1, cardBrand: 'PagoEfectivo', cardNumber: ''});
      this.closeModal(this.id);
    },
    sendYape() {
      this.addYapeInfo = true
    },
    async validateYapeInfo() {
      this.tryToSubmit = true
      if (!this.yapeInfo.number) return
      if (!this.yapeInfo.approbationCode) return

      this.$emit("getCardData", {cardId: -2, cardBrand: 'Yape', cardNumber: ''})
      this.closeModal(this.id)
      this.addYapeInfo = false
    },
    async registerCardWithIzipay() {
      console.log('this.user.id', this.user.id)
      this.tryToSubmit = true;
      if (!this.alias) return;

      try {
        this.showLoading();
        const session = await getIzipaySession();
        await loadIzipaySdk();
        this.$swal.close();

        const containerId = `izipay-form-container-${this.id}`;
        document.getElementById(containerId).innerHTML = '';

        const izi = new Izipay({
          config: {
            transactionId: session.transactionId,
            action: 'register',
            merchantCode: session.merchantCode,
            order: {
              orderNumber: session.orderNumber,
              currency: 'PEN',
              amount: '0.00',
              payMethod: 'CARD',
              processType: 'AT',
              merchantBuyerId: '0'.repeat(8 - String(this.user.id).length) + this.user.id,
              dateTimeTransaction: Date.now().toString(),
            },
            billing: this.billingFromUser(),
            render: {
              typeForm: Izipay.enums.typeForm.POP_UP,
              container: `#${containerId}`,
              showButtonProcessForm: true,
            },
          },
        });

        izi.LoadForm({
          authorization: session.authorization,
          keyRSA: session.publicKey,
          callbackResponse: (response) => this.onCardRegistered(response),
        });
      } catch (error) {
        this.$swal.close();
        this.showError(error.message || "Ocurrió un error interno al agregar la tarjeta");
      }
    },

    async onCardRegistered(response) {
      try {
        this.showLoading();
        await confirmIzipayCard({ ...response, alias: this.alias });
        this.$swal.close();
        this.showOk("¡Tarjeta agregada con éxito!", this.fetchCards);
        this.addCard = false;
        this.alias = '';
      } catch (error) {
        this.$swal.close();
        this.showError(error.message);
      }
    },

    billingFromUser() {
      return {
        firstName: this.user.name || 'Cliente',
        lastName: this.user.firstLastName || 'SAIO',
        email: this.user.email || 'cliente@saio.pe',
        phoneNumber: this.user.celular || '999999999',
        street: 'Av. Principal 123',
        city: 'Lima',
        state: 'Lima',
        country: 'PE',
        postalCode: '15001',
        document: this.user.nroDocumento || '00000000',
        documentType: 'DNI',
      };
    },
    handleCloseModal() {
      try {
        if (this.addCard) this.addCard = !this.addCard
        if (this.addYapeInfo) this.addYapeInfo = !this.addYapeInfo
        else this.closeModal(this.id)
      } catch (e) {
        console.log({ e })
      }
    }
  },
  mounted() {
    this.$nextTick(async () => {
      await this.fetchCards();
    });
  },
  computed: {
    cards() {
      return this.$store.getters.GENERAL_CARDS;
    },
    user() {
      return this.$store.getters.USER;
    },
  },
};
</script>

<style lang='scss'>
.StripeElement {
  height: 40px;
  display: flex;
  align-items: center;
  height: 44px !important;
}

#txtCvv > div > iframe {
  width: 150px;
}

.type-card-container {
  padding: 32px 20px;
  display: flex; flex-direction: column; gap: 32px;
  overflow-y: auto;
  max-height: 70vh;

  &::-webkit-scrollbar { width: 15px; }
  &::-webkit-scrollbar-thumb {
    background: rgba(26, 26, 26, 0.5);
    background-clip: content-box;
    border: 5px solid transparent;
    border-radius: 15px;
  }

  .card_info-button {
    cursor: pointer;
    transition: .3s;
    display: flex;
    padding: 16px;
    align-items: center;
    gap: 16px;
    align-self: stretch;

    border-radius: 12px;
    border: 1px solid var(--color-border-tertiary, #D0D0D0);
    background: var(--color-background-surface, #FFF);

    &:hover {
      border: 1px solid transparent;
      background: rgba(0, 0, 0, 0.08);
    }
    &:active {
      background: rgba(0, 0, 0, 0.20);
    }
  }
}
</style>
